export default "__VITE_ASSET__Bfad2JIw__"